import React, { useEffect, useState } from "react";
import OtpInput from "react-otp-input";
import OtpPageWrapper from "./OtpPageStyle";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import CountdownTimer from "./CountdownTimer";
import closeIcon from "../../assets/images/close-icon.svg";
import { useTranslation } from "react-i18next";
import { useDispatch,  } from "react-redux";
import { BUSINESS_LINE_COLORS } from "helpers/utils";
import { STORE_OTP } from "redux/actions/motorActions";

const OtpPage = ({
  verifyOTP,
  sendOTP,
  closeOTP,
  phone,
  mobileNumber,
  hideClose,
  margin = "0",
  isInternal = true,
  businessColor = BUSINESS_LINE_COLORS.DEFAULT
}) => {
  const { t, i18n } = useTranslation();
  const [otp, setOtp] = useState("");
  const [resetCounter, updateResetCounter] = useState(5 * 60);
  const [timer, setTimer] = useState("not Yet");
  const [firstSubmit, setFirstSubmit] = useState(true);
  const dispatch = useDispatch();

  // const mobileNumber = useSelector(
  // 	(state) => state.visa.beneficiariesDetails.Mobile
  // );

  const resendOTP = () => {
    sendOTP();
    updateResetCounter(+resetCounter - 1);
    // setTimeout(() => {
    //   updateResetCounter(false);
    // }, 500);
  };
  const handleOtpChange = () => {
    verifyOTP(otp)
      .then(() => {
        dispatch(STORE_OTP(otp));
      })
      .catch((error) => {
        console.error('Error verifying OTP:', error);
      });
  };


  useEffect(() => {
    if (firstSubmit && otp.length === 4) {
      verifyOTP(otp);
      dispatch(STORE_OTP(otp));
      setFirstSubmit(false);
    }
  }, [otp]);

  return (
    <Dialog
      className="dialog otp"
      visible={true}
      showHeader={false}
      closable={true}
      modal={true}
      maskClassName="test"
      onHide={() => {
        console.log("onHide");
      }}
    >
      <OtpPageWrapper 
      className={` ${i18n.language === "ar" ? "ar" : ""}`} businessColor={businessColor}>
        <div className="container-fluid" style={{ margin: 0, padding: 0 }}>
          <div className="d-flex justify-content-center">
            <div className="col-12 col-sm-12">
              {!hideClose && (
                <div className="otp-verification-close">
                  <img src={closeIcon} onClick={() => closeOTP()} />
                </div>
              )}
              <div className="d-flex justify-content-center">
                <div className="otp-verification-title">
                  <h2 className="otpVerificationTitle">{t("OTP.verificationTitle")}</h2>
                </div>
              </div>
              {isInternal ? (
                <div className="d-flex justify-content-center">
                  <p className="otpSentMessageStyle">
                    {t("OTP.otpsentMobile")}
                    <br />
                    {t("OTP.ending-with")} *****
                    <span className="fm-tawuniya">
                      {phone ? phone.slice(-4) : mobileNumber && mobileNumber.slice(-4)}
                    </span>
                  </p>
                </div>
              ) : (
                <div className="d-flex justify-content-center">
                  <p className="otpSentMessageStyle">
                    {t("OTP.otpSentAbsherMobile")}
                    <br />
                  </p>
                </div>
              )}

              <div className="verificationCodeTitle d-flex justify-content-center">
                {t("OTP.VERIFICATION_CODE")}
              </div>
              <div className="d-flex justify-content-center" dir="ltr">
                <OtpInput
                  isInputNum={true}
                  value={otp}
                  onChange={(code) => setOtp(code)}
                  placeholder="0000"
                  focusStyle={{
                    border: "1px solid #000",
                    outline: "none",
                    width: "60px",
                    height: "60px",
                  }}
                  separator={<span className="mx-1"></span>}
                  numInputs={4}
                  inputStyle="containerStyle numbers"
                  shouldAutoFocus={false}
                />
              </div>

              <div className="d-flex justify-content-center verifyButtonDiv">
                <Button
                  className="otpVerifybutton"
                  type="button"
                  disabled={!otp || otp.length < 4}
                  onClick={handleOtpChange}
                  label={t("OTP.verify")}
                />
              </div>

              <h4 className="countdownTextStyle">
                {t("OTP.RESEND_IN")} :
                <span className="countdownStyle numbers">
                  <CountdownTimer updatedOuterTimer={setTimer} count={resetCounter} />
                </span>
              </h4>
              <h3 className="resendOtp text-center">
                {t("OTP.DIDNT_REVICE_CODE")}
                <Button
                  disabled={timer !== "00:00"}
                  className="d-block p-button-text mx-auto my-2"
                  style={{
                    color: businessColor,
                    fontSize: "1rem",
                    fontWeight: "400",
                  }}
                  label={t("OTP.RESEND")}
                  onClick={() => resendOTP()}
                />
              </h3>
            </div>
          </div>
        </div>
      </OtpPageWrapper>
    </Dialog>
  );
};

export default OtpPage;
